import { EntityType } from "@mapmycustomers/shared";
import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import colors from "@app/styles/_colors.module.scss";

const getPinFillColor = (entityType?: EntityType): AnyColor => {
  switch (entityType) {
    case EntityType.COMPANY:
      return colors.primary100;
    case EntityType.DEAL:
      return colors.red100;
    case EntityType.PERSON:
      return colors.green100;
    default:
      return colors.slate;
  }
};

export default getPinFillColor;
